export default [{
    path: "/resume/detail/:id",
    name: "resumeDetail",
    meta: {
      title: "在线简历",
      requireAuth: true
    },
    component: () => import("./resumeDetail.vue")
  },
  {
    path: "/resume/candidateDetail/:id",
    name: "resumeCandidateDetail",
    meta: {
      title: "简历详情",
      requireAuth: true
    },
    component: () => import("./candidateDetail.vue")
  }
];